function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient",
  x1: 143.96,
  y1: 1370.29,
  x2: 237.27,
  y2: 1513.08,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-2",
  x1: -13.99,
  y1: 1366.97,
  x2: 185.53,
  y2: 1369.31,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#e5e9f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#dce1f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-3",
  x1: 191.89,
  y1: 1331.24,
  x2: 27.67,
  y2: 1196.76,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#e6eaf5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#d5dbee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-4",
  x1: 0.73,
  y1: 1291.69,
  x2: 210.26,
  y2: 1291.69,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-5",
  x1: -12.61,
  y1: 1248.02,
  x2: 187.12,
  y2: 1250.36,
  xlinkHref: "#failover-conf_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-6",
  x1: 197.68,
  y1: 1258.26,
  x2: 52.35,
  y2: 1159.43,
  xlinkHref: "#failover-conf_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-7",
  x1: 0.73,
  y1: 1226.77,
  x2: 210.26,
  y2: 1226.77,
  xlinkHref: "#failover-conf_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-8",
  x1: -11.85,
  y1: 1183.11,
  x2: 187.87,
  y2: 1185.45,
  xlinkHref: "#failover-conf_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-9",
  x1: 56.13,
  y1: 1065.85,
  x2: 243.12,
  y2: 1311.31,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-10",
  x1: 0.73,
  y1: 1161.85,
  x2: 210.26,
  y2: 1161.85,
  xlinkHref: "#failover-conf_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-11",
  x1: -8886.14,
  y1: 1304.94,
  x2: -8865.76,
  y2: 1342.71,
  gradientTransform: "matrix(-1 0 0 1 -8692.88 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-12",
  x1: 174.2,
  y1: 1309.13,
  x2: 207.41,
  y2: 1377.69,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#edf1f8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#e0e5f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-13",
  x1: -8854.34,
  y1: 1323.51,
  x2: -8833.96,
  y2: 1361.28,
  xlinkHref: "#failover-conf_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-14",
  x1: 137.68,
  y1: 1327.1,
  x2: 185.35,
  y2: 1401.02,
  xlinkHref: "#failover-conf_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-15",
  x1: -8886.14,
  y1: 1345.51,
  x2: -8865.76,
  y2: 1383.29,
  xlinkHref: "#failover-conf_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-16",
  x1: 178.39,
  y1: 1361.17,
  x2: 205.7,
  y2: 1408.84,
  xlinkHref: "#failover-conf_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-17",
  x1: -8854.34,
  y1: 1364.08,
  x2: -8833.96,
  y2: 1401.86,
  xlinkHref: "#failover-conf_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-18",
  x1: 141.21,
  y1: 1373.74,
  x2: 171.73,
  y2: 1419.8,
  xlinkHref: "#failover-conf_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-19",
  x1: 417.71,
  y1: 1604.27,
  x2: 644.67,
  y2: 1981.52,
  gradientTransform: "translate(0 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-20",
  x1: 566.1,
  y1: 1240.18,
  x2: 67.17,
  y2: 1794.12,
  gradientTransform: "translate(0 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#d8def0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#ebeff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#e9edf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#dee3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-21",
  x1: 222.35,
  y1: 1380.7,
  x2: 1234.44,
  y2: 2559.26,
  gradientTransform: "translate(0 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-22",
  x1: 179.89,
  y1: 1561.39,
  x2: 572.49,
  y2: 1561.39,
  gradientTransform: "translate(0 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-23",
  x1: 108,
  y1: 1645.32,
  x2: 178.65,
  y2: 1720.64,
  gradientTransform: "matrix(-1 0 0 1 674.88 -1276.45)",
  xlinkHref: "#failover-conf_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-24",
  x1: 108.79,
  y1: 1650.18,
  x2: 119.94,
  y2: 1629.63,
  gradientTransform: "matrix(-1 0 0 1 674.88 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#27335c",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-25",
  x1: 230.6,
  y1: 1710.09,
  x2: 111.71,
  y2: 1670.72,
  gradientTransform: "matrix(-1 0 0 1 674.88 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#007867"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#074b51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#0e233e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-26",
  x1: 145.49,
  y1: 1703.98,
  x2: 192.91,
  y2: 1657.74,
  xlinkHref: "#failover-conf_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-27",
  x1: 182.58,
  y1: 1694.96,
  x2: 97.38,
  y2: 1695.27,
  xlinkHref: "#failover-conf_svg__linear-gradient-25"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-28",
  x1: 182.57,
  y1: 1694.34,
  x2: 97.38,
  y2: 1694.65,
  xlinkHref: "#failover-conf_svg__linear-gradient-25"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-29",
  x1: 172.85,
  y1: 1685.09,
  x2: 146.36,
  y2: 1712.67,
  xlinkHref: "#failover-conf_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-30",
  x1: 93.74,
  y1: 1656.56,
  x2: 72.26,
  y2: 1661.64,
  xlinkHref: "#failover-conf_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "failover-conf_svg__linear-gradient-31",
  x1: 84.57,
  y1: 1703.77,
  x2: 114.04,
  y2: 1682.72,
  xlinkHref: "#failover-conf_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("style", null, ".failover-conf_svg__cls-8{fill:#5c71b3}.failover-conf_svg__cls-22{fill:#2d327e}.failover-conf_svg__cls-23{fill:#e5315a}.failover-conf_svg__cls-24{fill:#faac18}.failover-conf_svg__cls-33{fill:#8e9dcf}.failover-conf_svg__cls-42{fill:#bf7b43}.failover-conf_svg__cls-44{fill:#8e5b35}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M204.82 442.55L97.14 504.87l130.57 75.55 107.68-62.32z",
  fill: "url(#failover-conf_svg__linear-gradient)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 348.42L0 290.8v155.65a6 6 0 003.08 5.27l93.65 54.13a18.52 18.52 0 0018.34 0L207.91 452a6.1 6.1 0 003.08-5.27v-156l-95.92 57.62a18.52 18.52 0 01-18.34 0z",
  fill: "url(#failover-conf_svg__linear-gradient-2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 348.42L1.54 293.48a3 3 0 010-5.28l94.38-54.53a18.47 18.47 0 0118.34 0l95.19 54.94a3 3 0 010 5.27l-94.38 54.54a18.52 18.52 0 01-18.34 0z",
  fill: "url(#failover-conf_svg__linear-gradient-3)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M105.9 352.47a19.83 19.83 0 01-10-2.67L.73 294.86 2.35 292l95.19 55a16.61 16.61 0 0016.72 0l94.38-54.53 1.62 2.84-94.38 54.49a19.83 19.83 0 01-10 2.67z",
  fill: "url(#failover-conf_svg__linear-gradient-4)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 283.5L0 225.88v47.47a6 6 0 003.08 5.28l93.65 54.12a18.47 18.47 0 0018.34 0L207.91 279a6.1 6.1 0 003.08-5.27V226l-95.92 57.62a18.72 18.72 0 01-18.34-.08z",
  fill: "url(#failover-conf_svg__linear-gradient-5)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 283.5L1.54 228.56a3 3 0 010-5.28l94.38-54.53a18.47 18.47 0 0118.34 0l95.19 54.94a3 3 0 010 5.27l-94.38 54.54a18.52 18.52 0 01-18.34 0z",
  fill: "url(#failover-conf_svg__linear-gradient-6)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M105.9 287.55a19.83 19.83 0 01-10-2.67L.73 229.94l1.62-2.84L97.54 282a16.61 16.61 0 0016.72 0l94.38-54.53 1.62 2.84-94.38 54.54a19.83 19.83 0 01-10 2.67z",
  fill: "url(#failover-conf_svg__linear-gradient-7)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-8",
  d: "M117.34 312l87-50.23v-4.14l-87 50.23zm0-6.74l87-50.23v-4.14l-87 50.24z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 218.58L0 161v47.47a6 6 0 003.08 5.28l93.65 54.12a18.47 18.47 0 0018.34 0L207.91 214a6.1 6.1 0 003.08-5.27V161l-95.92 57.62a18.72 18.72 0 01-18.34-.08z",
  fill: "url(#failover-conf_svg__linear-gradient-8)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M96.73 218.58L1.54 163.64a3 3 0 010-5.28l94.38-54.53a18.47 18.47 0 0118.34 0l95.19 54.94a3 3 0 010 5.27l-94.38 54.54a18.52 18.52 0 01-18.34 0z",
  fill: "url(#failover-conf_svg__linear-gradient-9)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M105.9 222.63a19.74 19.74 0 01-10-2.68L.73 165l1.62-2.84 95.19 54.93a16.61 16.61 0 0016.72 0l94.38-54.53 1.62 2.84-94.38 54.6a19.74 19.74 0 01-10 2.68z",
  fill: "url(#failover-conf_svg__linear-gradient-10)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-8",
  d: "M117.34 247.06l87-50.23v-4.14l-87 50.23zm0-6.74l87-50.23V186l-87 50.23z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M105.9 203.81a14.94 14.94 0 01-7.63-2l-60-34.65a7.12 7.12 0 010-12.34l59.24-34.16a15.24 15.24 0 0115.34 0l60 34.65a7.11 7.11 0 010 12.33l-59.24 34.17a15.41 15.41 0 01-7.71 2zm-64.59-43.66a1.05 1.05 0 000 1.78l60 34.65a9.21 9.21 0 009.17 0l59.24-34.16a1 1 0 00.48-.89 1 1 0 00-.48-.9l-60-34.65a9.26 9.26 0 00-9.17 0z",
  fill: "#cfd6ec"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M168.06 365.54c0-5.52 3.9-12.17 8.69-14.93 2.51-1.46 4.78-1.55 6.41-.49l10.14 5.76-12.09 21.18-10.55-6c-1.54-.81-2.6-2.76-2.6-5.52z",
  fill: "url(#failover-conf_svg__linear-gradient-11)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M178.53 371.54c0 5.52 3.9 7.71 8.68 4.95s8.69-9.41 8.69-14.93-3.9-7.71-8.69-4.95-8.68 9.39-8.68 14.93z",
  fill: "url(#failover-conf_svg__linear-gradient-12)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M136.25 384.12c0-5.52 3.9-12.17 8.68-14.93 2.52-1.46 4.79-1.54 6.42-.49l10.14 5.76-12.09 21.19-10.55-6c-1.62-.81-2.6-2.76-2.6-5.52z",
  fill: "url(#failover-conf_svg__linear-gradient-13)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M146.72 390.13c0 5.52 3.89 7.71 8.68 4.95s8.69-9.42 8.69-14.93-3.9-7.71-8.69-4.95-8.68 9.41-8.68 14.93z",
  fill: "url(#failover-conf_svg__linear-gradient-14)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M168.06 406.11c0-5.51 3.9-12.17 8.69-14.93 2.51-1.46 4.78-1.54 6.41-.49l10.14 5.77-12.09 21.18-10.55-6c-1.54-.81-2.6-2.76-2.6-5.52z",
  fill: "url(#failover-conf_svg__linear-gradient-15)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M178.53 412.12c0 5.52 3.9 7.71 8.68 4.95s8.69-9.41 8.69-14.93-3.9-7.71-8.69-4.95-8.68 9.41-8.68 14.93z",
  fill: "url(#failover-conf_svg__linear-gradient-16)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M136.25 424.7c0-5.52 3.9-12.18 8.68-14.93 2.52-1.47 4.79-1.55 6.42-.49l10.14 5.72-12.09 21.22-10.55-6c-1.62-.82-2.6-2.76-2.6-5.52z",
  fill: "url(#failover-conf_svg__linear-gradient-17)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M146.72 430.7c0 5.52 3.89 7.71 8.68 4.95s8.69-9.41 8.69-14.93-3.9-7.71-8.69-5-8.68 9.46-8.68 14.98z",
  fill: "url(#failover-conf_svg__linear-gradient-18)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M195.33 550.43a7.49 7.49 0 01-7.39 0l-56.78-33a2.43 2.43 0 010-4.22l16.07-9.21a17 17 0 008.52-14.77v-63.56a.48.48 0 00-.08-.32c-12-27.35.48-39.52.64-39.69a.8.8 0 10-1.05-1.21c-.57.48-13.47 13-1.06 41.3v63.38a15.22 15.22 0 01-7.7 13.31l-16.07 9.25a4 4 0 000 7l56.78 33a9 9 0 009 0",
  fill: "#454fa1"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M28.16 357.5v-18.34l-10.55-6.24v18.34zm15.74 9.09v-18.34L33.35 342v18.34z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-23",
  d: "M59.65 375.68v-18.34l-10.55-6.25v18.34z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M75.39 384.69v-18.26l-10.55-6.25v18.34z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-24",
  d: "M28.16 381.85v-18.34l-10.55-6.25v18.34z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M43.9 390.94V372.6l-10.55-6.25v18.34zM59.65 400v-18.31l-10.55-6.25v18.34z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-24",
  d: "M75.39 409v-18.22l-10.55-6.25v18.34z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M28.16 406.19v-18.34l-10.55-6.24V400zm15.74 9.09v-18.34l-10.55-6.24V409z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-24",
  d: "M59.65 424.37V406l-10.55-6.22v18.34z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M75.39 433.38v-18.26l-10.55-6.25v18.34zm-47.23-2.84V412.2L17.61 406v18.34zm15.74 9.09v-18.34L33.35 415v18.34z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-23",
  d: "M59.65 448.72v-18.34l-10.55-6.25v18.34zm15.74 9v-18.25l-10.55-6.25v18.34z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M529.08 766.37L180.48 565.1l396.1-226.64 348.6 201.26z",
  fill: "url(#failover-conf_svg__linear-gradient-19)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M562.22.54a3.77 3.77 0 00-3.89 0L172.81 222.89a9.89 9.89 0 00-4.93 8.51V555a3.85 3.85 0 002 3.42l13.84 8-2.31-327.2a9.9 9.9 0 014.94-8.52L575.75 8.33z",
  fill: "url(#failover-conf_svg__linear-gradient-20)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M186.34 230.68L571.69 8.41a3.93 3.93 0 015.89 3.42v323.63a9.71 9.71 0 01-4.94 8.51L187.37 566.16a3.93 3.93 0 01-5.89-3.42V239.12a9.69 9.69 0 014.86-8.44z",
  fill: "url(#failover-conf_svg__linear-gradient-21)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M183.07 562.82h-3.18v-323.7a11.37 11.37 0 015.73-9.87L570.89 7.06l1.6 2.78L187.13 232a8.23 8.23 0 00-4.14 7.08l.08 323.7z",
  fill: "url(#failover-conf_svg__linear-gradient-22)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M204.31 240.63L553.55 39.2a4.2 4.2 0 016.29 3.66v282a10.4 10.4 0 01-5.25 9.07L205.35 535.37a4.2 4.2 0 01-6.29-3.66V249.78a10.7 10.7 0 015.25-9.15z",
  fill: "#444"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M229.91 373.06a6.81 6.81 0 001.84 1.5 8.56 8.56 0 005.55.75 22.72 22.72 0 007.7-3 35.6 35.6 0 006.72-5 32.55 32.55 0 005.08-6.08 28.26 28.26 0 002.65-5.23zm26.28-55.78a8.55 8.55 0 00-5.1-.53 20.81 20.81 0 00-7 2.75A32.51 32.51 0 00233 330.09a29.11 29.11 0 00-2 3.65l26.72-15.42a6.4 6.4 0 00-1.53-1.04zm13.27 32.94a6.68 6.68 0 001.7 1.62q4.35 2.84 12-1.59a32.14 32.14 0 0013.72-15.87zm25.73-54.72q-4.33-3-12 1.45a31.29 31.29 0 00-12 12.42c-.3.55-.58 1.11-.84 1.67L296 296.19a5.58 5.58 0 00-.81-.69zm12.59 32.6v6.9l28.54-16.48v-6.92zm8.37-49.17l-8.37 4.83v5.65l8.37-4.83zm52.25-30.17v5.65l8.37-4.83v-5.65zm-19.56 58.6q4 2.65 12-1.93a30.4 30.4 0 0013.83-15.92l-27.65 16a6.74 6.74 0 001.82 1.85zm4.34-49.81l-8.37 4.83V268l8.37-4.83zM383.62 240v5.64l32-18.45v-5.65zm11.8 44.44l8.37-4.83v-6.92l-8.37 4.83zm28.15-16.28L453.25 251v-6.92l-29.68 17.14zm0-51.25v5.65l29.68-17.14v-5.64zm39.93 21.28a6.68 6.68 0 001.7 1.62q4.35 2.83 12-1.6a32.21 32.21 0 0013.71-15.85zm25.73-54.72q-4.34-3-12 1.44a31.33 31.33 0 00-12 12.43c-.3.55-.58 1.11-.84 1.67l25.72-14.85a5.58 5.58 0 00-.88-.69zm33.96 22.35l-1.14.65-.23-1.95-7.39 4.27.77 6.47 16.36-9.45v-6.91l-8.37 4.83zm0-46.42v5.6l8.37-4.83v-5.65zm-6.34 3.66l-16.36 9.44v5.65l8.37-4.83v-.82l1.14-.66.1.76 7.39-4.26zm-16.36 60.7l8.37-4.84V212l-8.37 4.83zM416 302.7v-1.32a21.73 21.73 0 00-1-7.3 7.9 7.9 0 00-3.1-4.21 7.36 7.36 0 00-5.11-.86 20.17 20.17 0 00-7 2.71 30.76 30.76 0 00-6.85 5.38 33.87 33.87 0 00-5.2 7.1 35.24 35.24 0 00-3.3 8.5 39.06 39.06 0 00-1.14 9.48v11.42q0 10.26 4.44 13t11.99-1.6a31.78 31.78 0 0012.08-11.91 33 33 0 004.19-16.47v-1.32l-8.37 4.83v1.32a25.12 25.12 0 01-.32 4 15.66 15.66 0 01-1.17 4 14.29 14.29 0 01-2.41 3.66 16 16 0 01-4 3.13 8.67 8.67 0 01-3.78 1.34 3.18 3.18 0 01-2.5-.94 6 6 0 01-1.39-2.82 18.26 18.26 0 01-.45-4.32v-12.88a23 23 0 01.48-4.63 19.88 19.88 0 011.49-4.53 17.72 17.72 0 012.53-3.95 13.68 13.68 0 013.62-3 7.64 7.64 0 013.8-1.28 3.23 3.23 0 012.41 1 5.47 5.47 0 011.27 2.56 14.71 14.71 0 01.38 3.45v1.31zm34.42-34.76q-4.34-3-12 1.45a31.21 31.21 0 00-12 12.43 37.07 37.07 0 00-4.34 18v11.41q0 10.26 4.34 13.1t12-1.6a31.44 31.44 0 0012-12.28 36.76 36.76 0 004.35-18.11v-11.46q0-9.94-4.35-12.94zm-4 29.78a31 31 0 01-.38 4.91 17.35 17.35 0 01-1.33 4.43 15.41 15.41 0 01-2.48 3.81 15 15 0 01-3.8 3 8.62 8.62 0 01-3.81 1.36 3.17 3.17 0 01-2.47-.95 5.69 5.69 0 01-1.33-2.89 23.37 23.37 0 01-.38-4.47v-12.56a25.75 25.75 0 01.45-4.8 19.09 19.09 0 011.39-4.47 16.77 16.77 0 012.47-3.88 14 14 0 013.68-3 7.25 7.25 0 013.68-1.2 3.37 3.37 0 012.47 1 6.14 6.14 0 011.4 2.86 18.91 18.91 0 01.44 4.28zm37.96-53.85v46.42l-1.14.66-5.24-43.42-16.32 9.47v51.25l8.37-4.83V257l1.15-.66 5.19 43.43 16.36-9.45V239zm46.23-17.46v-9.23l-28.41 16.4v51.25l8.37-4.83v-21.08l14.82-8.56v-9.22l-14.82 8.55V238zm20.09 21.75a3 3 0 00-1.3-1.44 3.32 3.32 0 00-1.94-.35 5.56 5.56 0 00-2.31.78 10 10 0 00-2.35 1.91 15.44 15.44 0 00-1.9 2.56 13.78 13.78 0 00-1.3 2.94 10.28 10.28 0 00-.48 3 5.73 5.73 0 00.48 2.47 3 3 0 001.3 1.44 3.39 3.39 0 001.9.37 5.55 5.55 0 002.35-.81 9.84 9.84 0 002.31-1.88 14.76 14.76 0 001.94-2.58 13.64 13.64 0 001.3-3 10.18 10.18 0 00.47-3 5.75 5.75 0 00-.47-2.41z",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#c1ff00",
  d: "M542.6 194.93L219.35 381.55v-43.49L542.6 151.44v43.49z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M254.35 333.19L243 339.75v3.52l6.89-4v6l-6.89 4v9.95l-6.08 3.51v-25.47l17.44-10.07zm39.11-3.13l-6.62 3.81-1.19-3.78-6.65 3.82-1.2 5.16-6.55 3.78 8-30.06 6.17-3.56zm-9.29-4.71l-.41-1.44c-.79-2.81-1.13-4-1.42-5.54-.28 1.87-.63 3.49-1.41 7.18l-.41 1.91zm39.7-12.86l-6.23 3.6v-25.44l6.23-3.6zm43.74-25.25l-15.93 9.2V271l6.17-3.56v19.3l9.76-5.63zm41.83-36.91c0 8.47-4.25 15.61-10.23 19.07S389 270.65 389 262.18s4.25-15.61 10.23-19.06 10.21-1.26 10.21 7.21zm-6.33 3.73c0-4.58-1.44-6.18-3.9-4.76s-3.84 4.58-3.84 9.16 1.45 6.18 3.9 4.76 3.84-4.58 3.84-9.16zm46.55-39.63l-7.59 29.82-6.17 3.57-7.59-21.07 6.87-4 1.6 5.91c.76 2.72 1.83 7.27 2.24 9.47.4-2.68 1.48-8.42 2.23-12l1.61-7.76zm35.88 4.73l-17.1 9.84v-25.42l16.88-9.74v5.93L474.49 206v3.38l6.51-3.76v5.85l-6.51 3.76v4.36l11.05-6.38zM525.71 196l-6.83 3.95-3.59-6.51-2.45 1.42v8.58l-6 3.47v-25.49l9.85-5.68c5.16-3 8.59-2.71 8.59 3.32a14.28 14.28 0 01-4 9.74zm-6.51-13.21c0-1.6-.76-2.29-2.68-1.18l-3.68 2.13v5.56l3.59-2.08a4.83 4.83 0 002.77-4.47z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M532.93 451.07l80.51-46.46-80-46.14L453 404.93z",
  fill: "url(#failover-conf_svg__linear-gradient-23)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-33",
  d: "M574.38 353.54a1.64 1.64 0 011.51 1.75 15 15 0 01-1 8 4.8 4.8 0 01-1.19 1.83 5 5 0 01-2.07.95 46.33 46.33 0 01-21.16 1.11c-3.82-.71-7.64-2-10.26-4.77-2.79-2.94-4.69-10.74 1-11.45 6.84-1 14.32-.08 21.16.63 4 .56 8 1.19 12.1 2z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M574.38 353.54a1.64 1.64 0 011.51 1.75 15 15 0 01-1 8 4.8 4.8 0 01-1.19 1.83 5 5 0 01-2.07.95 46.33 46.33 0 01-21.16 1.11c-3.82-.71-7.64-2-10.26-4.77-2.79-2.94-4.69-10.74 1-11.45 6.84-1 14.32-.08 21.16.63 4 .56 8 1.19 12.1 2z",
  fill: "url(#failover-conf_svg__linear-gradient-24)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M444.15 457.12a12.64 12.64 0 006-1.59l93.24-53.86A11.94 11.94 0 10531.42 381l-93.24 53.85a11.94 11.94 0 006 22.28z",
  fill: "url(#failover-conf_svg__linear-gradient-25)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M481.54 424.1a116.93 116.93 0 001-14.87L531.5 381a11.94 11.94 0 1111.93 20.68L478.83 439c1.12-4.93 2.07-9.94 2.71-14.88z",
  fill: "url(#failover-conf_svg__linear-gradient-26)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M526 439.54a11.72 11.72 0 007.4-2.63l22.35-17.82a11.94 11.94 0 10-14.88-18.69l-22.35 17.82a12 12 0 007.48 21.32z",
  fill: "url(#failover-conf_svg__linear-gradient-27)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-33",
  d: "M557.67 367.54c2.15-.63 5.25-1 7.32.24 5 3.1 9.55 9.15 13.84 13.29a9.26 9.26 0 012.71 3.66 7.55 7.55 0 01-.16 4c-1.75 7.08-6 13.13-11 18.38-5.41 5.73-18.22 18-25.3 21.8 0 0-4-30.07-30.07-38.27-.01-.19 22.22-17.37 42.66-23.1z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-33",
  d: "M561.41 364.84c-.48-.4-1-.72-1.43-1.12a78.08 78.08 0 01-9.71-8.75 13.54 13.54 0 00-10.34-4.05c-2.86.15-7 1.75-7.48 5a9.94 9.94 0 00.88 4.77 51.75 51.75 0 004.21 8.75c1.52 2.55 2.87 5.41 4.86 7.56 1.59 1.75 4.05 2.31 6.36 2.7 3.34.56 7.32.48 10.18-1.51a26.5 26.5 0 005.73-4.53c3.1-3.9-.24-6.61-3.26-8.83z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M499.36 462.85a11.84 11.84 0 0011.77-10.27l3-22.11.64 1.67a12 12 0 0015.59 6.52c6.13-2.46 8.6-24.82 6.13-30.94l-17-27.29a12 12 0 00-22.91 2.86l-9.15 66a11.94 11.94 0 0010.19 13.45 13.33 13.33 0 001.75.08z",
  fill: "url(#failover-conf_svg__linear-gradient-28)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M516.22 412.17c1.2 5 2.23 10.1 4.62 14.72a30.65 30.65 0 0010.42 11.22 9 9 0 01-.8.47 12 12 0 01-15.59-6.52l-.64-1.67z",
  fill: "url(#failover-conf_svg__linear-gradient-29)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-33",
  d: "M608.66 384.33a71.89 71.89 0 00-13.12-16.15 7.6 7.6 0 00-3.9-2.15c-1.67-.16-3.18.88-4.54 1.83s-3 2.15-4.45 3.26a1.55 1.55 0 00-.72.88 1.42 1.42 0 00.32 1.11c5.49 10.18 9.55 20 19.41 26.73a22.27 22.27 0 007.88 3.58c9 1.75 5.73-7.4 3.18-12.09-1.27-2.31-2.62-4.7-4.06-7z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M608.66 384.33a71.89 71.89 0 00-13.12-16.15 7.6 7.6 0 00-3.9-2.15c-1.67-.16-3.18.88-4.54 1.83s-3 2.15-4.45 3.26a1.55 1.55 0 00-.72.88 1.42 1.42 0 00.32 1.11c5.49 10.18 9.55 20 19.41 26.73a22.27 22.27 0 007.88 3.58c9 1.75 5.73-7.4 3.18-12.09-1.27-2.31-2.62-4.7-4.06-7z",
  fill: "url(#failover-conf_svg__linear-gradient-30)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-33",
  d: "M562.68 408.27a23.38 23.38 0 011.91-6.44c1.12-2.63 1.51-5.41 2.39-8.12a97.21 97.21 0 014.93-12.33c.56-1.19 1.43-2.54 2.78-2.54 1.91 0 2.95 1.19 4.38 2.15 1.67 1 3.66 1.83 5.41 2.7a50 50 0 0011.3 4.22c5.8 1.19 11.93 2.46 16.46 6.6a12.2 12.2 0 013.19 4.06 6.47 6.47 0 01.23 5 7.1 7.1 0 01-3.5 3.5c-5.33 3-32.21-2.55-39.3-.88-1.75.4-6.6 3.43-7.47 4-2.31 1.2-3 .32-2.71-1.91z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M559.26 410.82c1.75-3.58 4.14-7.08 7.8-8.83 3.82-1.91 8.35-1.51 12.33-.32a37 37 0 0110.26 5c-7.08-.71-13.76-1.27-16.86-.56a13.58 13.58 0 00-2.63 1.2c-3.42 3.58-9.71 9.62-15.59 14.64 1.67-3.74 2.94-7.56 4.69-11.14z",
  fill: "url(#failover-conf_svg__linear-gradient-31)"
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  className: "failover-conf_svg__cls-42",
  cx: 581.62,
  cy: 362.29,
  r: 15.12
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M595.46 371.44c-1.2.56-3 .4-3.5-.8a4.46 4.46 0 01-.08-2.3 13.93 13.93 0 00-.16-4.46c-.56-2.7-1.27-5.65 1.91-6.92 1.91-.79 4.45-.64 5.89 1 3.18 3.66-.08 11.85-4.06 13.52z",
  fill: "#ec6977"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-42",
  d: "M595.78 374.38c-5.81 4-12.41-5.72-7.24-10.18a6 6 0 017.4-.16c3.26 2.39 3.18 8.12-.16 10.34z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-44",
  d: "M596.09 369.45a.29.29 0 00.24-.08.49.49 0 00.16-.56c-.08-.08-1.83-2.78-6.68-.87a.36.36 0 00-.24.48.42.42 0 00.56.24c4.21-1.68 5.65.39 5.73.55-.08.16.08.24.23.24z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-44",
  d: "M593 371.6a.44.44 0 00.4-.24c.08-.08 1.11-2.78-.72-4a.48.48 0 00-.55.08c-.16.16-.08.4.16.56 1.35.87.47 3 .47 3a.34.34 0 00.24.48c-.16.08-.08.08 0 .08z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M575.89 357.12a4.46 4.46 0 01-3.18-2.07c-.56-1.19.16-2.94 1.51-2.86a11.53 11.53 0 01-4.38-.08 3.55 3.55 0 01-2.62-3.18c.08-1.59 1-2.23 2.38-2.79.64-.32 3.34-1.27 3.9-.63a7.41 7.41 0 01-2.31-3.9 4.18 4.18 0 011.36-4.14c2.07-1.59 5.09-.32 7.32 1.11a52.74 52.74 0 017 5.33c-1.59-.55-1.91-2.94-.8-4.21a4.12 4.12 0 014.61-.8 11.11 11.11 0 013.9 3.11c2.87 3.34 6 6.92 7 11.29.4 1.75.64 4.46-.31 6.13-1.12 1.91-2.79 1.11-4.7.79a9 9 0 00-5.73.8c-2.14 1.11-5.09 3.5-7.47 1.43-1.52-1.35-1-5.25 1.35-5.17a18.32 18.32 0 01-8.83-.16z",
  fill: "#df1d39"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-42",
  d: "M563.8 371.68c.47-1 6.52-5.57 7-5.65a2.16 2.16 0 01.71.08 12 12 0 016.84 4.14 16.49 16.49 0 003.35 3.26c-2.79 2.23-6.29 7.64-10.27 6.84-4.77-.88-9.07-5.81-7.63-8.67z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "failover-conf_svg__cls-22",
  d: "M434.76 428.24a21.72 21.72 0 01-2.78-3.42c-.88-1.35-1.67-2.78-2.63-4.14-1.75-2.46-4.22-4.45-7.48-3.58-4.61 1.28-4.53 4.86-4.77 8.75a199.79 199.79 0 00.24 26.81c.24 4.94.24 11.06 4.45 14.32a6 6 0 003 1.28 7.68 7.68 0 002.94-.8c4.22-1.83 8.11-4.3 12.25-6.28 1.67-.8 4.38-1.75 5.49-3.19s1-4.53 1.11-6.36a31.29 31.29 0 00-2.46-13.76 2.8 2.8 0 01-.4-1.59c.16-2.47 2-4.7-1.43-6.37a5.77 5.77 0 00-3.5-.24 4.51 4.51 0 01-4.06-1.43zm77.33 11.93c.55-.16.95-.24.87-.16 1.83 2.95 2.55 8.2 3.34 11.7.4 1.67.72 3.58-.24 5a6.93 6.93 0 01-2 1.75c-5.1 3.5-11 5.89-16.23 9.15-4.54 2.86-9.71 4.45-14.88 5.89-2.23.55-4.53 1.11-6.68.31-9.71-3.81 3.66-18.69 7.24-23.07a13.72 13.72 0 002.94-6.36c.4-2 .56-2.86 2.47-3.18a20.15 20.15 0 015.8.16c1.44.24 2.15 1.83 3.5 2.22s3.11-.23 4.54-.55c.79-.16 6.92-2.23 9.31-2.87z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M492.6 452.27c.15 0 .23-.08.39-.16a.61.61 0 00.08-.8 9.76 9.76 0 00-8.67-3.1.6.6 0 00-.48.63c0 .32.32.48.64.48a8.4 8.4 0 017.64 2.79.61.61 0 00.4.16zm-4.3 3.97a.48.48 0 00.32-.08.61.61 0 00.16-.79 7.1 7.1 0 00-8.2-2.55c-.31.08-.39.4-.31.72s.39.4.71.32a6.12 6.12 0 016.84 2.14.48.48 0 00.48.24zm-5.57 4.22a.29.29 0 00.24-.08.62.62 0 00.24-.8 4.84 4.84 0 00-6.13-1.9.53.53 0 10.48.95 3.68 3.68 0 014.69 1.43.59.59 0 00.48.4z",
  fill: "#f2f5fa"
});

function SvgFailoverConf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 925.18 766.37"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    id: "failover-conf_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "failover-conf_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, /*#__PURE__*/React.createElement("path", {
    d: "M552 376.13a17.16 17.16 0 00-9.86 2.87c-2.15 1.51-3.34 3.5-3.34 5.33s1.19 3.74 3.26 5.25a16.81 16.81 0 009.7 2.86 17.21 17.21 0 009.87-2.86c2.15-1.51 3.34-3.5 3.34-5.33s-1.19-3.74-3.26-5.25a16.51 16.51 0 00-9.71-2.87z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.4,
    fill: "#cfd6ec"
  }))));
}

export default __webpack_public_path__ + "static/failover-conf.6e06b958.svg";
export { SvgFailoverConf as ReactComponent };